import * as standardPriceAction from './standard-price-action'

export {
  standardPriceAction,
}



// WEBPACK FOOTER //
// ./src/actions/standard-price/index.js